import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#FF7F0A"
      d="M15 1.25a.75.75 0 0 1 .732.585l.538 2.392a4.635 4.635 0 0 0 3.503 3.503l2.392.538a.75.75 0 0 1 0 1.464l-2.392.538a4.635 4.635 0 0 0-3.503 3.503l-.538 2.392a.75.75 0 0 1-1.464 0l-.538-2.392a4.635 4.635 0 0 0-3.503-3.503l-2.392-.538a.75.75 0 0 1 0-1.464l2.392-.538a4.635 4.635 0 0 0 3.503-3.503l.538-2.392A.75.75 0 0 1 15 1.25ZM7 11.25a.75.75 0 0 1 .732.585l.384 1.708a3.096 3.096 0 0 0 2.34 2.34l1.709.385a.75.75 0 0 1 0 1.464l-1.708.384a3.096 3.096 0 0 0-2.34 2.34l-.385 1.709a.75.75 0 0 1-1.464 0l-.384-1.709a3.096 3.096 0 0 0-2.34-2.34l-1.709-.384a.75.75 0 0 1 0-1.464l1.708-.385a3.096 3.096 0 0 0 2.34-2.34l.385-1.708A.75.75 0 0 1 7 11.25Z"
    />
  </svg>
)
export default SvgComponent
